module.exports = __webpack_public_path__ + "static/gr_0-e7aa600e7788faf1b8230e754f95b37d.jpg";